// Single source of truth for contact details shown across the site.
// (Structured data in public/index.html must be updated by hand.)

export const PHONES = [
  { label: "Mobile", display: "+91 98195 07465", tel: "+919819507465" },
  { label: "Office", display: "+91 81699 63284", tel: "+918169963284" },
  { label: "Landline", display: "022-27652694", tel: "+912227652694" },
];

// The number used for "Call Us" buttons, so a tap on a phone dials it directly.
export const PRIMARY_PHONE = PHONES[0];

export const EMAILS = ["bidaver@gmail.com", "scb.civil@gmail.com", "rcb_govtcontractor@yahoo.com"];

export const ISO = {
  standard: "ISO 9001:2015",
  certificateNo: "20DQHT71",
};
